import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import { TextField, Button, Typography, useMediaQuery, useTheme } from '@mui/material';
import { styled } from '@mui/system';

const Contact = () => {
  const form = useRef();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const sendEmail = (e) => {
    e.preventDefault();

    // console.log("Service ID:", process.env.REACT_APP_EMAILJS_SERVICE_ID);
    // console.log("Template ID:", process.env.REACT_APP_EMAILJS_TEMPLATE_ID);
    // console.log("Public Key:", process.env.REACT_APP_EMAILJS_USER_ID);

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_EMAILJS_USER_ID
      )
      .then(
        (result) => {
          console.log(result.text);
          console.log("message sent");
          alert('Your message has been sent successfully!');
          form.current.reset();
        },
        (error) => {
          console.log(error.text);
          alert('Failed to send the message, please try again.');
        }
      );
  };

  const StyledForm = styled('form')(({ theme }) => ({
    width: '100%',
    fontSize: '16px',
    '& .MuiTextField-root': {
      marginBottom: '15px',
    },
    '& .MuiButton-root': {
      marginTop: '15px',
    },
    '& .MuiInputLabel-root': {
      color: 'rgba(0, 0, 0, 0.6)',
      '&.Mui-focused': {
        color: '#f9004d',
      }
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'rgba(0, 0, 0, 0.23)',
      },
      '&:hover fieldset': {
        borderColor: '#f9004d',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#f9004d',
      }
    },
  }));

  return (
    <StyledContactForm isMobile={isMobile}>
      <Typography variant="h4" component="div" gutterBottom sx={{
        fontWeight: 'bold',
        textAlign: 'center',
        fontSize: isMobile ? '30px' : '40px',
        color: 'black',
        marginBottom: '2%'
      }}>Contact <span style={{ color: '#f9004d' }}>Me</span>
      </Typography>

      <StyledForm ref={form} onSubmit={sendEmail}>
        <TextField
          label="Name"
          variant="outlined"
          name="user_name"
          fullWidth
        />

        <TextField
          label="Email"
          variant="outlined"
          name="user_email"
          type="email"
          fullWidth
        />

        <TextField
          label="Message"
          variant="outlined"
          name="message"
          fullWidth
          multiline
          rows={4}
        />

        <Button
          type="submit"
          sx={{
            backgroundColor: '#f9004d',
            borderRadius: '5px',
            color: 'white',
            fontWeight: 'bold',
            fontSize: isMobile ? '12px' : '15px',
            transition: '.5s',
            border: '2px solid transparent',
            '&:hover': {
              backgroundColor: 'transparent',
              color: 'black',
              border: '2px solid #f9004d'
            }
          }}
        >
          Send
        </Button>
      </StyledForm>
    </StyledContactForm>
  );
};

export default Contact;

const StyledContactForm = styled('div')(({ isMobile }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: isMobile ? 2 : 4,
  gap: 2,
  width: isMobile ? '80%' : '50%',
  margin: 'auto',
}));
  